<template>
  <div v-if="student" class="student-card py-3 px-4">
    <v-layout
      v-if="$mq !== 'mobile'"
      row wrap>
      <v-flex sm4 md3 py-1>
        <div><strong>Name:</strong></div>
        <div>{{ student.studentName }}</div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>Student ID:</strong></div>
        <div>{{ student.studentExtId }}</div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>Birth Date:</strong></div>
        <div>{{ student.birthDate | formatDate}}</div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>Gender:</strong></div>
        <div>{{ student.gender }}</div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>Grade:</strong></div>
        <div>{{ student.grade }}</div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>School Name:</strong></div>
        <div>{{ student.schoolName }}</div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>Service Type:</strong></div>
        <div>{{ student.serviceName }}</div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>Frequency:</strong></div>
        <div>{{ student.frequency }}</div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>ESY:</strong></div>
        <div><span v-if="student.esy">YES</span><span v-else>NO</span></div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>Projected Start Date:</strong></div>
        <div>{{ student.startDate | formatDate }}</div>
      </v-flex>
      <v-flex sm4 md3 py-1>
        <div><strong>Projected End Date:</strong></div>
        <div>{{ student.endDate | formatDate }}</div>
      </v-flex>
    </v-layout>
    <template v-else>
      <div><strong>{{ student.studentName }} ({{ student.studentExtId }})</strong></div>
      <div>
        <span>{{ student.schoolName }}</span>
        <span class="pr-3">Gr: {{ student.grade }}</span>
        {{ student.serviceName }}
      </div>
      <div>
        <span>
          {{ student.startDate | formatDate }} - {{ student.endDate | formatDate }}
        </span>
        ESY:
        <span v-if="student.esy">YES</span><span v-else>NO</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'StudentCard',
  props: ['student']
};
</script>

<style lang="scss" scoped>
  .student-card {
    background: var(--v-primary-base);
    color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 12px rgba(32, 41, 89, 0.8);
  }
</style>



// WEBPACK FOOTER //
// src/components/service-log/form/student-card.vue